import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = API_URLS.CUSTOMERS;
const basePathMarkers = API_URLS.MARKERS;
const markersUpdatePath = `${API_URLS.MARKERS.replace("/markers", "")}/messages/markers/update`;



async function findAddress(address) {
  try {
    // Codificar o endereço para URL
    const encodedAddress = encodeURIComponent(address);
    var url = `${basePath}/locations/coordinates?address=${encodedAddress}`
    console.log("URL da API:", url);

    let response = await api.get(url);
    console.log("Resposta bruta da API:", response);

    let treated = errorHandling.handleResponse(
      response,
      "controlService.findAddress"
    );
    console.log("Resposta tratada:", treated);

    if (treated) {
      return treated;
    }
    return null;

  } catch (error) {
    console.error("Erro na API findAddress:", error);
    errorHandling.cathError(error, "controlService.findAddress");
    return null;
  }
};

async function findCoordinate(markerTypeId, markerId) {
  try {
    var url = `${basePathMarkers}/active-markers?markerTypeId=${markerTypeId}`

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "controlService.findCoordinate"
    );
    if (treated) {
      return treated;
    }
    return null;

  } catch (error) {
    errorHandling.cathError(error, "controlService.findCoordinate");
    return null;
  }
};

async function deleteAddress(markerId, markerTypeId) {
  try {
    var url = `${basePathMarkers}/${markerId}/${markerTypeId}`

    let response = await api.delete(url);

    let treated = errorHandling.handleResponse(
      response,
      "controlService.deleteAddress"
    );
    if (response.status === 204) {
      return response;
    }
    return treated;

  } catch (error) {
    errorHandling.cathError(error, "controlService.deleteAddress");
    return null;
  }
};

async function updateCoordinate(payload) {
  try {
    var url = `${basePathMarkers}`

    let response = await api.put(url, JSON.stringify(payload));

    let treated = errorHandling.handleResponse(
      response,
      "controlService.updateCoordinate"
    );
    if (treated) {
      return treated;
    }
    return null;

  } catch (error) {
    errorHandling.cathError(error, "controlService.updateCoordinate");
    return null;
  }
};

async function createFences(payload) {
  try {
    var url = `${basePathMarkers}`

    let response = await api.post(url, JSON.stringify(payload));

    let treated = errorHandling.handleResponse(
      response,
      "controlService.createFences"
    );
    if (treated) {
      return treated;
    }
    return null;

  } catch (error) {
    errorHandling.cathError(error, "controlService.createFences");
    return null;
  }
};

async function bindPointControl(payload) {
  try {
    var url = `${basePathMarkers}/linked-vehicle`

    let response = await api.patch(url, JSON.stringify(payload));

    if (response.status === 204) {
      return { success: true };
    }

    let treated = errorHandling.handleResponse(
      response,
      "controlService.bindPointControl"
    );
    if (treated) {
      return treated;
    }
    return null;

  } catch (error) {
    errorHandling.cathError(error, "controlService.bindPointControl");
    return null;
  }
};

async function fetchBindPointControl(markerTypeId, markerId, vehicleGroupId = null) {
  try {
    var url = `${basePathMarkers}/linked-vehicles?markerTypeId=${markerTypeId}&markerId=${markerId}`

    if (vehicleGroupId !== null && vehicleGroupId !== undefined && vehicleGroupId !== 0) {
      url += `&vehicleGroupId=${vehicleGroupId}`;
    }

    let response = await api.get(url);

    let treated = errorHandling.handleResponse(
      response,
      "controlService.fetchBindPointControl"
    );
    if (treated) {
      return treated;
    }
    return null;

  } catch (error) {
    errorHandling.cathError(error, "controlService.fetchBindPointControl");
    return null;
  }
};

async function unbindPointControl(payload) {
  try {
    var url = `${basePathMarkers}/linked-vehicle`

    let response = await api.delete(url, { data: payload });

    // 204 No Content é sucesso para DELETE
    if (response.status === 204) {
      return { success: true };
    }

    let treated = errorHandling.handleResponse(
      response,
      "controlService.unbindPointControl"
    );
    if (treated) {
      return treated;
    }
    return { success: true };

  } catch (error) {
    errorHandling.cathError(error, "controlService.unbindPointControl");
    return null;
  }
};

async function updateMarkers() {
  try {
    const response = await api.put(markersUpdatePath, {});

    if (response.status === 204) {
      return { success: true };
    }

    const treated = errorHandling.handleResponse(
      response,
      "controlService.updateMarkers"
    );
    if (treated) {
      return treated;
    }

    return response?.data ?? null;
  } catch (error) {
    errorHandling.cathError(error, "controlService.updateMarkers");
    return null;
  }
};

async function findPolygon(markerId) {
  try {
    var url = `${basePathMarkers}/${markerId}/polygon`

    let response = await api.get(url);
    console.log("Resposta bruta da API:", response);

    let treated = errorHandling.handleResponse(
      response,
      "controlService.findPolygon"
    );
    console.log("Resposta tratada:", treated);

    if (treated) {
      return treated;
    }
    return null;

  } catch (error) {
    console.error("Erro na API findPolygon:", error);
    errorHandling.cathError(error, "controlService.findPolygon");
    return null;
  }
};

async function exportSchedules(scheduleQueueId) {
  try {
    var url = `${basePathMarkers}/${scheduleQueueId}/file`

    let response = await api.get(url, { responseType: 'blob' });

    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `schedule_${scheduleQueueId}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return true;

  } catch (error) {
    console.error("Erro na API exportSchedules:", error);
    errorHandling.cathError(error, "controlService.exportSchedules");
    return null;
  }
};

async function listSchedules(scheduleQueueId, eventTypeId, completed, active) {
  try {
    const params = [];
    
    if (scheduleQueueId) params.push(`ScheduleQueueId=${scheduleQueueId}`);
    if (eventTypeId) params.push(`EventTypeId=${eventTypeId}`);
    if (completed) params.push(`Completed=${completed}`);
    if (active) params.push(`Active=${active}`);
    
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    var url = `${basePathMarkers}/schedules${queryString}`;

    let response = await api.get(url);
    console.log("Resposta bruta da API:", response);

    let treated = errorHandling.handleResponse(
      response,
      "controlService.listSchedules"
    );
    console.log("Resposta tratada:", treated);

    if (treated) {
      return treated;
    }
    return null;

  } catch (error) {
    console.error("Erro na API listSchedules:", error);
    errorHandling.cathError(error, "controlService.listSchedules");
    return null;
  }
};

async function createSchedules() {
  try {
    var url = `${basePathMarkers}/schedules`

    let response = await api.post(url);
    console.log("Resposta bruta da API:", response);

    let treated = errorHandling.handleResponse(
      response,
      "controlService.createSchedules"
    );
    console.log("Resposta tratada:", treated);

    if (treated) {
      return treated;
    }
    return null;

  } catch (error) {
    console.error("Erro na API createSchedules:", error);
    errorHandling.cathError(error, "controlService.createSchedules");
    return null;
  }
};

async function createAndExportSchedules() {
  try {
    const scheduleResponse = await createSchedules();
    
    if (!scheduleResponse) {
      console.error("Erro: scheduleQueueId não retornado");
      return null;
    }

    const scheduleQueueId = scheduleResponse;
    console.log("ScheduleQueueId criado:", scheduleQueueId);

    const exportResponse = await exportSchedules(scheduleQueueId);
    
    return exportResponse;

  } catch (error) {
    console.error("Erro na API createAndExportSchedules:", error);
    errorHandling.cathError(error, "controlService.createAndExportSchedules");
    return null;
  }
};

export const controlService = {
  findCoordinate,
  findAddress,
  deleteAddress,
  updateCoordinate,
  bindPointControl,
  unbindPointControl,
  updateMarkers,
  createFences,
  fetchBindPointControl,
  findPolygon,
  exportSchedules,
  listSchedules,
  createSchedules,
  createAndExportSchedules,
}
